<!--  -->
<template>
  <div class="stencil-container">
    <a-layout class="st-container">
      <a-layout-content class="st-main">
        <a-layout>
          <!--左-->
          <a-layout-sider theme="light" :width="250" class="st-slider">
            <ComponentGroup
              title="基础字段"
              :fields="basicFields"
              :list="basic"
              :disabled="groupDisabled"
            />
          </a-layout-sider>
          <!--中-->
          <a-layout class="center-container">
            <div class="st-data-search">
              <div class="data-left">
                <div class="data-switch">
                  <span class="switch-span">数据查询关联</span>
                  <a-switch v-model:checked="checked" :disabled="route.query.status" />
                </div>
                <div class="data-select" v-if="checked">
                  <span class="select-span">关联活动查询模板</span>
                  <a-select
                    v-model:value="switchFormState.activeType"
                    placeholder="请选择类型"
                    class="switchSelect"
                    :disabled="route.query.status"
                  >
                    <a-select-option
                      :value="item.id"
                      v-for="(item,index) in switchOption"
                      :key="item.id"
                    >{{item.name}}</a-select-option>
                  </a-select>
                </div>
              </div>
              <div class="data-btn">
                <a-button
                  type="primary"
                  shape="round"
                  @click="createTemplateChange"
                  :loading="loading"
                >
                  <template #icon>
                    <span class="btn-span" v-if="!route.query.isDetail">
                      <Icon icon="folder-add-line" />
                      <span class="icon-span">生成模版</span>
                    </span>
                    <span class="btn-span" v-if="route.query.isDetail">
                      <Icon icon="save-line" />
                      <span class="icon-span">保存模版</span>
                    </span>
                  </template>
                </a-button>
                <a-button type="dashed" class="exit-btn" @click="goBack">退出</a-button>
              </div>
            </div>
            <a-layout-content :class="{ 'widget-empty': widgetForm.list }">
              <TreeConfig
                v-model:treeSum="treeSum"
                @addOption="addOption"
                @treeSelect="treeSelect"
                @iconChange="iconChange"
                @cancelPop="cancelPop"
              />

              <WidgetForm
                v-model:widgetForm="widgetForm"
                v-model:widgetFormSelect="widgetFormSelect"
              />
            </a-layout-content>
          </a-layout>
          <!--右-->
          <a-drawer
            title="字段属性"
            placement="right"
            :closable="true"
            :mask="false"
            :width="drawWidth"
            v-model:visible="visible"
            @close="closeVisibleChange"
          >
            <WidgetConfig v-model:select="widgetFormSelect" />
          </a-drawer>
        </a-layout>
      </a-layout-content>
    </a-layout>
    <a-modal
      v-model:visible="modalVisible"
      :title="modalTitle"
      @ok="handleOk"
      @cancel="handelCancel"
      cancelText="取消"
      okText="确定"
    >
      <div v-if="modalStatus === 1|| modalStatus === 0">
        <a-form
          :model="modalFormState"
          :rules="modalRules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          ref="modalRef"
        >
          <a-form-item label="节点名称" name="nodeName">
            <a-input v-model:value="modalFormState.nodeName" @change="nameChange" />
          </a-form-item>
          <a-form-item label="key" name="nodeKey">
            <a-input v-model:value="modalFormState.nodeKey" @change="keyChange" />
          </a-form-item>
        </a-form>
      </div>
      <p v-if="modalStatus === 2">确定要删除当前节点以及节点里的内容吗？</p>
      <p v-if="modalStatus === 3">退出后内容不会保存确定退出吗？</p>
    </a-modal>
  </div>
</template>

<script>
import {
  defineComponent,
  onBeforeMount,
  ref,
  reactive,
  toRefs,
  computed,
  toRaw,
  watchEffect,
  watch,
  onMounted
} from "vue";
import ComponentGroup from "@/components/ComponentGroup";
import { basicComponents, WidgetFormInterface } from "@/config/antd";
import WidgetConfig from "../../components/widgetConfig";
import WidgetForm from "../../components/widgetForm";
import TreeConfig from "../../components/treeConfig";
import { useStore } from "vuex";
import Icon from "@/layout/icon";
import {
  getTreeParentChilds,
  getTreeDataByKey,
  getKey,
  isHasChildren
} from "@/utils/index";
import { message } from "ant-design-vue";
import { templateConfig, activeDetail } from "@/api/index.js";
import { useRoute, useRouter } from "vue-router";
// 导入的其他文件 例如：import moduleName from 'modulePath';
export default defineComponent({
  components: {
    ComponentGroup,
    WidgetConfig,
    WidgetForm,
    TreeConfig,
    Icon
  },
  props: {
    basicFields: {
      type: Array,
      default: () => [
        "input",
        "password",
        "textarea",
        "number",
        "radio",
        "checkbox",
        "time",
        "date",
        "rate",
        "select",
        "switch",
        "slider",
        "text",
        "upload"
      ]
    }
  },
  setup(props, { attrs, slots, emit }) {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const basic = ref([]);
    const treeSum = reactive({
      selectedKeys: [],
      treeData: [],
      expandedKeys: [],
      popVisible: false
    });
    const state = reactive({
      widgetForm: JSON.parse(JSON.stringify(WidgetFormInterface)),
      widgetFormSelect: null,
      modalVisible: false,
      modalTitle: "添加选项",
      modalStatus: 0, // 0: 添加选项 1:编辑选项 2:删除节点 3: 退出
      hover: false,
      // expandedKeys: [],
      addOptionChild: 0,
      eidtOption: 0,
      groupDisabled: true,
      iconStatus: 0, // 0 添加 1 编辑 2 删除
      treeCurrentItem: null,
      treeSelectKey: null,
      checked: false,
      switchOption: [
        {
          id: 1,
          name: "投票"
        },
        {
          id: 2,
          name: "抽奖"
        },
        {
          id: 3,
          name: "答题"
        },
        {
          id: 4,
          name: "邀请"
        }
      ],
      widgetDisabled: false,
      loading: false,
      screenWidth: null,
      deleteTreeNode: []
    });
    let isDetailClick = ref(false);
    // draw
    let visible = computed(() => store.state.settings.drawerVisble);
    const drawWidth = computed(() => {
      return state.screenWidth > 2400 ? 400 : 300;
    });
    // widgetForm
    // switch
    const switchFormState = reactive({
      activeType: null
    });
    const switchRules = {
      activeType: [
        {
          required: true,
          message: "Please select Activity zone",
          trigger: "change"
        }
      ]
    };

    // model
    const modalRef = ref();
    const modalFormState = reactive({
      nodeName: null,
      nodeKey: null
    });

    const modalRules = {
      nodeName: [
        {
          required: true,
          message: "请输入节点名称",
          trigger: "blur"
        }
      ],
      nodeKey: [
        {
          required: true,
          message: "请输入key",
          trigger: "blur"
        }
      ]
    };
    const getActiveDetail = () => {
      let params = {};
      activeDetail(params, route.query.id).then(res => {
        console.log(res, "zheshidetail");
        if (res.status === 200) {
          console.log(
            res.data.activitiesMeta.activitiesNodes,
            "res.data.activitiesMeta;"
          );

          treeSum.treeData = isHasChildren(
            res.data.activitiesMeta.activitiesNodes
          );
          console.log(treeSum.treeData, "这是赋值后的");
        }
      });
    };
    // 退出
    const goBack = () => {
      state.modalTitle = "退出";
      state.modalStatus = 3;
      state.modalVisible = true;
    };
    //创建模版
    const createTemplateChange = () => {
      // 改造数据
      console.log(treeSum.treeData, "treeData");
      state.loading = true;
      let params = {
        activitiesNodes: treeSum.treeData,
        type: state.checked ? switchFormState.activeType : 0
      };
      if (route.query.isDetail) {
        params.deleteNodeIds = state.deleteTreeNode;
      }
      templateConfig(params, route.query.id).then(res => {
        console.log(res, "0000000000000");
        if (res.status === 200) {
          setTimeout(() => {
            state.loading = false;
            let text = "模版创建成功！";
            if (route.query.isDetail) {
              text = "保存成功！";
            }
            message.success(text);
            router.replace({
              name: "eventList"
            });
          }, 2000);
        }
      });
    };
    const resetForm = () => {
      modalRef.value.resetFields();
    };
    const handelCancel = () => {
      state.modalTitle = null;
      if (state.modalStatus === 1 || state.modalStatus === 0) {
        resetForm();
      }
    };
    const handleOk = e => {
      if (state.modalStatus === 0 || state.modalStatus === 1) {
        modalRef.value
          .validate()
          .then(() => {
            state.modalVisible = false;
            state.modalTitle = null;
            switch (state.iconStatus) {
              case 0:
                addOptionHandle();
                break;
              case 1:
                eidtOptionHandle();
                break;
            }
            resetForm();
          })
          .catch(error => {
            console.log("error", error);
          });
      } else if (state.modalStatus === 3) {
        state.modalTitle = null;
        state.modalVisible = false;
        router.push({
          name: "listItem"
        });
      } else {
        state.modalTitle = null;
        deleteOptionHandle();
      }
    };
    const closeVisibleChange = () => {
      store.commit("settings/drawerVisbleChange", false);
    };
    // tree add
    const iconChange = (status, treeKey) => {
      console.log(status, treeKey, "00");
      state.iconStatus = status;
      state.treeSelectKey = treeKey;
      switch (status) {
        case 0:
          addTree();
          break;
        case 1:
          editTree();
          break;
        case 2:
          deleteTree();
          break;
      }
    };
    const addOption = () => {
      state.modalVisible = true;
      state.modalStatus = 0; // modal
      treeSum.selectedKeys = []; // 如果添加时选中 则清空
      state.iconStatus = 0;
      if (treeSum.treeData.length > 0) {
        state.addOptionChild = 1;
      }
    };
    // 判断是否有重复的key
    let getAllKey = computed(() => {
      let hasKey = getKey(treeSum.treeData);
      return hasKey.find(item => item === modalFormState.nodeKey);
    });
    const addOptionHandle = () => {
      if (!getAllKey.value) {
        console.log("没有有");
        // 添加
        if (treeSum.treeData.length === 0) {
          treeSum.treeData.push({
            title: modalFormState.nodeName,
            key: modalFormState.nodeKey,
            children: [],
            contents: {},
            id: 0
            // id: new Boolean(route.query.isDetail) ? route.query.id : 0
          });
        } else {
          if (state.addOptionChild === 1) {
            treeSum.treeData.push({
              title: modalFormState.nodeName,
              key: modalFormState.nodeKey,
              children: [],
              contents: {},
              id: 0
            });
            state.addOptionChild = 0;
          } else {
            addSubChilds();
          }
        }
      } else {
        console.log("有");
        message.error("key不可重复！");
      }

      // 清空拖拽
      state.widgetForm.list = [];
      state.widgetDisabled = false;
    };
    // 添加下级
    const addSubChilds = () => {
      let selectItem = getTreeDataByKey(treeSum.treeData, state.treeSelectKey);
      if (!selectItem.children) {
        selectItem.children = [];
      }
      selectItem.children.push({
        title: modalFormState.nodeName,
        key: modalFormState.nodeKey,
        children: [],
        contents: {},
        id: 0
      });
    };

    const treeSelect = (selectedKeys, e) => {
      isDetailClick.value = true;
      let selectItem = getTreeDataByKey(treeSum.treeData, selectedKeys?.[0]);
      if (selectItem) {
        console.log(selectItem, "treeSelect");
        if (
          selectItem.contents.hasList &&
          selectItem.contents.hasList.length > 0
        ) {
          if (route.query.isDetail) {
            state.widgetForm.list = selectItem.contents.list;
          } else {
            state.widgetForm.list = selectItem.contents.hasList;
          }
        } else {
          state.widgetForm.list = [];
        }
        console.log(treeSum.treeData, "selectDataTre");
        // dataSort()
      }
    };
    const addTree = () => {
      // resetForm();
      modalFormState.nodeName = null;
      modalFormState.nodeKey = null;
      state.modalVisible = true;
      state.modalTitle = "添加选项";
      state.modalStatus = 0;
    };
    // 删除
    const deleteTree = () => {
      state.modalTitle = "删除节点";
      state.modalStatus = 2;
      state.modalVisible = true;
    };
    const deleteOptionHandle = () => {
      state.modalVisible = false;
      let parent = getTreeParentChilds(treeSum.treeData, state.treeSelectKey);
      let delIndex = parent.findIndex(item => item.key === state.treeSelectKey);
      const del = parent.find(item => item.key === state.treeSelectKey);
      console.log(del, "del");
      state.deleteTreeNode.push(del.id);
      parent.splice(delIndex, 1);
    };
    // 编辑
    const editTreeSelect = () => {
      return getTreeDataByKey(treeSum.treeData, state.treeSelectKey);
    };
    const eidtOptionHandle = () => {
      state.treeCurrentItem.title = modalFormState.nodeName;
      if (getAllKey.value === modalFormState.nodeKey) {
        if (modalFormState.nodeKey === state.treeCurrentItem.key) {
          return;
        }
        message.error("key不可重复！");
        return;
      }
      state.treeCurrentItem.key = modalFormState.nodeKey;
    };
    const editTree = () => {
      state.modalTitle = "编辑选项";
      state.modalStatus = 1;
      state.modalVisible = true;
      state.eidtOption = 1;
      state.treeCurrentItem = editTreeSelect();
      modalFormState.nodeName = editTreeSelect()?.title;
      modalFormState.nodeKey = editTreeSelect()?.key;
    };
    // 拖动事件

    // 处理数据
    const dataSort = () => {
      let selectItem = getTreeDataByKey(
        treeSum.treeData,
        treeSum.selectedKeys[0]
      );
      if (selectItem) {
        console.log(selectItem, "selectItemdtataSrot");
        let hasList = toRaw(state.widgetForm.list);
        selectItem.contents = {
          hasList: JSON.parse(JSON.stringify(state.widgetForm.list)),
          list: hasList
          // rulesConfig: {}
        };
      }
      console.log(treeSum.treeData, "treDatatata");
    };
    let isDisabled = computed(() => {
      console.log(isDetailClick, "isDetailClick");
      if (treeSum.treeData.length > 0) {
        return false;
      }
      return true;
    });
    // tree delete pop
    const cancelPop = () => {
      treeSum.popVisible = false;
    };
    watch(
      [isDisabled, isDetailClick],
      ([newDisabled, newIsDetailClick], [preDisabled, preIsDetailClick]) => {
        console.log(newDisabled, "newDisDisabled");
        console.log(newIsDetailClick, "newIsDetailClick");
        if (newIsDetailClick) {
          state.groupDisabled = newDisabled;
        }
      }
    );
    watchEffect(() => {
      dataSort();
    });
    const keyChange = () => {
      modalFormState.nodeKey = modalFormState.nodeKey.replace(
        /[\u4E00-\u9FA5]/g,
        ""
      );
      modalFormState.nodeKey = modalFormState.nodeKey.replace(/\s/g, "");
    };
    const nameChange = () => {
      modalFormState.nodeName = modalFormState.nodeName.replace(/\s/g, "");
    };
    onBeforeMount(() => {
      basic.value = basicComponents;
    });
    onMounted(() => {
      console.log(route, "route.query.isDetail");
      if (route.query.isDetail) {
        getActiveDetail();
      }
      if (route.query.type) {
        state.checked = true;
        switchFormState.activeType = Number(route.query.type);
      }
      state.screenWidth = window.innerWidth;
      window.onresize = () => {
        return (() => {
          state.screenWidth = window.innerWidth;
        })();
      };
    });
    return {
      ...toRefs(state),
      route,
      basic,
      visible,
      closeVisibleChange,
      //tree
      addOption,
      treeSum,
      treeSelect,
      iconChange,
      // modal
      modalRef,
      modalFormState,
      modalRules,
      resetForm,
      handelCancel,
      handleOk,
      cancelPop,
      //switch
      switchFormState,
      switchRules,
      createTemplateChange,
      goBack,
      drawWidth,
      keyChange,
      nameChange,
      labelCol: {
        span: 4
      },
      wrapperCol: {
        span: 14
      }
    };
  }
});
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
@import "./index.less";
</style>